import { useState } from "react";
import Navbar from "../components/Navbar";

export default function Schemes() {
  const [search, setSearch] = useState("");
  const [department, setDepartment] = useState("");
  const [selectedScheme, setSelectedScheme] = useState(null);

  const schemes = [
    {
      id: 1,
      dept: "स्वास्थ्य विभाग",
      name: "जन्म प्रमाण पत्र",
      details: "नवजात शिशु का जन्म प्रमाण पत्र बनवाने की सरकारी सुविधा।",
    },

    {
      id: 2,
      dept: "स्वास्थ्य विभाग",
      name: "जननी बाल सुरक्षा योजना (JBSY)",
      details: "गर्भवती महिलाओं के सुरक्षित प्रसव हेतु वित्तीय सहायता।",
    },

    {
      id: 3,
      dept: "स्वास्थ्य विभाग",
      name: "टीकाकरण",
      details: "बच्चों के लिए मुफ्त टीकाकरण कार्यक्रम।",
    },

    {
      id: 4,
      dept: "स्वास्थ्य विभाग",
      name: "आयुष्मान कार्ड (PMJAY)",
      details: "गरीब परिवारों के लिए ₹5 लाख तक स्वास्थ्य बीमा।",
    },

    {
      id: 5,
      dept: "आईसीडीएस",
      name: "प्रधानमंत्री मातृ वंदना योजना (PMMVY)",
      details: "गर्भवती महिलाओं को आर्थिक सहायता।",
    },

    {
      id: 6,
      dept: "आईसीडीएस",
      name: "मुख्यमंत्री कन्या उत्थान योजना",
      details: "बालिकाओं की शिक्षा और सशक्तिकरण हेतु योजना।",
    },

    {
      id: 7,
      dept: "डाक विभाग",
      name: "सुकन्या समृद्धि योजना",
      details: "बालिका के भविष्य के लिए बचत योजना।",
    },

    {
      id: 8,
      dept: "मनरेगा",
      name: "बकरी पालन, गड्ढा, फूड प्रो",
      details: "मनरेगा के अंतर्गत रोजगार योजनाएं।",
    },

    {
      id: 9,
      dept: "मनरेगा",
      name: "जॉब कार्ड (मनरेगा)",
      details: "ग्रामीण परिवारों को रोजगार उपलब्ध कराने की योजना।",
    },

    {
      id: 10,
      dept: "ग्रामीण विकास विभाग",
      name: "लोहिया स्वच्छ बिहार अभियान",
      details: "स्वच्छता और शौचालय निर्माण योजना।",
    },

    {
      id: 11,
      dept: "ग्रामीण विकास विभाग",
      name: "आवास योजना",
      details: "गरीब परिवारों को आवास उपलब्ध कराना।",
    },

    {
      id: 12,
      dept: "उद्योग विभाग",
      name: "बिहार लघु उद्योग योजना",
      details: "छोटे उद्योगों को बढ़ावा देने की योजना।",
    },

    {
      id: 13,
      dept: "जीविका",
      name: "जीविका समूह योजना",
      details: "महिलाओं के स्वयं सहायता समूहों को सशक्त बनाना।",
    },

    {
      id: 14,
      dept: "श्रम एवं संसाधन विभाग",
      name: "लेबर कार्ड",
      details: "मजदूरों के लिए सरकारी लाभ।",
    },

    {
      id: 15,
      dept: "श्रम एवं संसाधन विभाग",
      name: "कुशल युवा कार्यक्रम (KYP)",
      details: "युवाओं को कौशल प्रशिक्षण।",
    },

    {
      id: 16,
      dept: "DRCC",
      name: "स्टूडेंट क्रेडिट कार्ड",
      details: "उच्च शिक्षा के लिए ऋण सुविधा।",
    },

    {
      id: 17,
      dept: "खाद्य एवं उपभोक्ता संरक्षण",
      name: "राशन कार्ड",
      details: "सस्ते अनाज के लिए पात्रता कार्ड।",
    },

    {
      id: 18,
      dept: "उद्योग विभाग",
      name: "प्रधानमंत्री मुद्रा योजना",
      details: "छोटे व्यापार के लिए ऋण योजना।",
    },

    {
      id: 19,
      dept: "उद्योग विभाग",
      name: "प्रधानमंत्री रोजगार सृजन योजना",
      details: "स्वरोजगार को बढ़ावा देने की योजना।",
    },

    {
      id: 20,
      dept: "शिक्षा विभाग",
      name: "कस्तूरबा गांधी बालिका विद्यालय",
      details: "बालिकाओं के लिए आवासीय विद्यालय।",
    },

    {
      id: 21,
      dept: "सामाजिक सुरक्षा विभाग",
      name: "पेंशन योजना",
      details: "वृद्ध, विधवा एवं दिव्यांगजन के लिए पेंशन।",
    },

    {
      id: 22,
      dept: "राजस्व विभाग",
      name: "जाति प्रमाण पत्र",
      details: "जाति प्रमाण पत्र जारी करने की सेवा।",
    },

    {
      id: 23,
      dept: "राजस्व विभाग",
      name: "निवास प्रमाण पत्र",
      details: "निवास प्रमाण पत्र जारी करने की सेवा।",
    },

    {
      id: 24,
      dept: "राजस्व विभाग",
      name: "आय प्रमाण पत्र",
      details: "आय प्रमाण पत्र जारी करने की सेवा।",
    },
  ];

  const departments = [...new Set(schemes.map((s) => s.dept))];

  const filtered = schemes.filter((s) => {
    return (
      s.name.toLowerCase().includes(search.toLowerCase()) &&
      (department === "" || s.dept === department)
    );
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <Navbar />

      <div className="max-w-7xl mx-auto p-8">
      <h1 className="text-4xl font-bold text-center text-indigo-700 mb-2">
  सरकारी योजनाएं
</h1>

<p className="text-center text-gray-600 mb-8">
  लाभार्थियों के लिए उपलब्ध सरकारी योजनाओं की जानकारी
</p>

        {/* Filters */}

        <div className="flex flex-wrap gap-4 mb-6">
        <input
  type="text"
  placeholder="🔍 योजना खोजें..."
  className="border p-3 rounded-lg w-72 shadow focus:ring-2 focus:ring-indigo-400 outline-none"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <select
  className="border p-3 rounded-lg shadow focus:ring-2 focus:ring-indigo-400 outline-none"
            value={department}
            onChange={(e) => setDepartment(e.target.value)}
          >
            <option value="">All Departments</option>

            {departments.map((d) => (
              <option key={d}>{d}</option>
            ))}
          </select>
        </div>

        {/* Scheme Cards */}

        <div className="grid md:grid-cols-3 gap-6">
  {filtered.map((s) => (
    <div
      key={s.id}
      className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition cursor-pointer"
      onClick={() => setSelectedScheme(s)}
    >
      <span className="text-xs bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full">
        {s.dept}
      </span>

      <h3 className="font-bold text-lg mt-3">{s.name}</h3>

      <p className="text-gray-600 text-sm mt-2">
        {s.details}
      </p>
    </div>
  ))}
</div>
      </div>

      {/* Modal */}

      {selectedScheme && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center">
          <div className="bg-white rounded-xl p-8 w-[420px] shadow-2xl">
            <h2 className="text-xl font-bold mb-2">{selectedScheme.name}</h2>

            <p className="text-gray-600 mb-4">{selectedScheme.details}</p>

            <button
              onClick={() => setSelectedScheme(null)}
              className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-lg transition"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
